import React from 'react'
import { useLocation } from 'react-router-dom'
import {
	SDropDownDivider,
	SLink,
	SLinkContainer,
	SLinkDropDownContainer,
	SLinkIcon,
	SLinkLabel,
	SLinkNotification,
	SLinkLogo,
	SDropdownWrapper, // ← add
	SChevron
} from './styles'
import THORSwapLogo from '../../assets/logos/thorswap/thorswapLogo.jpg'
import THORWalletLogo from '../../assets/logos/thorwallet/thorwalletLogo.jpg'
import XDEFILogo from '../../assets/logos/xdefi/xdefiLogo.jpg'
import { AiOutlineSwap, AiOutlineLeft, AiOutlineDown } from 'react-icons/ai'
import { TbAddressBook, TbWallet } from 'react-icons/tb'
import { FaNetworkWired, FaSwimmingPool } from 'react-icons/fa'
import { MdDashboard } from 'react-icons/md'
import { RiExchangeDollarLine } from 'react-icons/ri'
import { BsPiggyBank } from 'react-icons/bs'
import { BsBank, BsSafe, BsWater } from 'react-icons/bs'
import { GiReceiveMoney } from 'react-icons/gi'
import { FiExternalLink } from 'react-icons/fi'
import { RiSecurePaymentFill } from 'react-icons/ri'
import { FaRegMoneyBillAlt } from 'react-icons/fa'

function SidebarList(props) {
	const filteredLinksArray = []

	const { pathname } = useLocation()
	for (let i = 0; i < linksArray.length; i++) {
		const element = Object.create(linksArray[i])
		if (props.searchText === '') {
			filteredLinksArray.push(element)
		} else {
			if (element.dropDownLinksArray) {
				const tempList = []
				for (let i = 0; i < element.dropDownLinksArray.length; i++) {
					if (element.dropDownLinksArray[i].label.toLowerCase().includes(props.searchText)) {
						tempList.push(element.dropDownLinksArray[i])
					}
				}
				if (tempList.length > 0) {
					element.dropDownLinksArray = tempList
					filteredLinksArray.push(element)
				}
			} else {
				if (element.label.toLowerCase().includes(props.searchText)) {
					filteredLinksArray.push(element)
				}
			}
		}
	}
	if (props.searchText !== '' && filteredLinksArray.length > 0) {
		filteredLinksArray.forEach((element) => {
			props.dropdownOpen[element.label] = true
		})
	}

	return (
		<>
			{filteredLinksArray.map(({ icon, label, dropDown, to, dropDownLinksArray }) => (
				<div key={label}>
					<SLinkContainer
						isActive={props.pathname === to}
						onClick={() => {
							if (dropDownLinksArray) {
								props.setSidebarOpen(true)
							}
							props.setDropdownOpen((prevState) => ({
								...prevState,
								[label]: !props.dropdownOpen[label]
							}))
						}}
					>
						<SLink to={to ? to : pathname} style={!props.sidebarOpen ? { width: `fit-content` } : {}}>
							<SLinkIcon>{icon}</SLinkIcon>
							{props.sidebarOpen && (
								<>
									<SLinkLabel>{label}</SLinkLabel>
									{/* if dropDown are at 0 or null, do not display */}
									{!!dropDown && (
										<SLinkNotification>
											<SChevron isOpen={props.dropdownOpen[label]}>
												<AiOutlineDown />
											</SChevron>
										</SLinkNotification>
									)}
								</>
							)}
						</SLink>
					</SLinkContainer>

					{dropDownLinksArray && (
						<SDropdownWrapper isOpen={props.dropdownOpen[label] && props.sidebarOpen}>
							{dropDownLinksArray.map(({ label: subLabel, to }) => (
								<SLinkDropDownContainer key={subLabel} isActive={props.pathname === to}>
									<SLink to={to} style={!props.sidebarOpen ? { width: `fit-content` } : {}}>
										<SDropDownDivider />
										<SLinkLabel style={{ fontSize: '14px' }}>{subLabel}</SLinkLabel>
									</SLink>
								</SLinkDropDownContainer>
							))}
						</SDropdownWrapper>
					)}
				</div>
			))}
		</>
	)
}
const linksArray = [
	{
		label: 'Dashboard',
		icon: <MdDashboard />,
		to: '/',
		dropDown: 0
	},
	// SWAPS
	{
		label: 'Swaps',
		icon: <AiOutlineSwap />,
		to: undefined,
		dropDown: 1,
		dropDownLinksArray: [
			{
				label: 'Swap Volume',
				to: '/thorchain_swap_volume'
			},
			{
				label: 'Swap Volume By Chain',
				to: '/thorchain_swap_volume_by_chain'
			},
			{
				label: 'Swap Volume PCT By Chain',
				to: '/thorchain_swap_volume_pct_by_chain'
			},
			{
				label: 'Swap Volume By Depth',
				to: '/thorchain_swap_volume_by_depth'
			},
			{
				label: 'Swap Fees By Chain',
				to: '/thorchain_swap_fees_by_chain'
			},
			{
				label: 'Swap Fees By Type',
				to: '/thorchain_swap_fees_by_type'
			},
			{
				label: 'Swap Count',
				to: '/thorchain_swap_count'
			},
			{
				label: 'Swap Distribution',
				to: '/thorchain_swap_count_distribution'
			},
			{
				label: 'Unique Swapper Count',
				to: '/thorchain_unique_swap_count'
			},
			{
				label: 'Refund Events Count',
				to: '/thorchain_refund_events'
			}
		]
	},
	// LP
	{
		label: 'Liquidity',
		icon: <FaSwimmingPool />,
		to: undefined,
		dropDown: 1,
		dropDownLinksArray: [
			// {
			// 	label: 'Realized P/L',
			// 	to: '/thorchain_lp_realized_pl'
			// },
			// {
			// 	label: 'Net Realized P/L',
			// 	to: '/thorchain_lp_net_realized_pl'
			// },
			// {
			// 	label: 'Net Unrealized P/L',
			// 	to: '/thorchain_lp_unrealized_pl'
			// },
			{
				label: 'Liquidity Distribution',
				to: '/thorchain_lp_liquidity_distribution'
			},
			{
				label: 'LP Distribution',
				to: '/thorchain_lp_distribution'
			},
			{
				label: 'Net Liquidity Change',
				to: '/thorchain_net_liquidity_change'
			},
			{
				label: 'ILP Paid',
				to: '/thorchain_ilp_paid'
			}
			// {
			// 	label: 'Avg LP Age',
			// 	to: '/thorchain_avg_lp_age'
			// }
		]
	},
	// POL
	{
		label: 'POL',
		icon: <BsWater />,
		to: undefined,
		dropDown: 1,
		dropDownLinksArray: [
			{
				label: 'Total POL Value',
				to: '/thorchain_total_pol_value'
			},
			{
				label: 'Income POL Deployments',
				to: '/thorchain_income_pol_deployments'
			},
			{
				label: 'Income POL Value',
				to: '/thorchain_income_pol_value'
			},
			{
				label: 'Income POL P/L',
				to: '/thorchain_income_pol_unrealized_pl'
			},
			{
				label: 'Reserve POL Deployments',
				to: '/thorchain_reserve_pol_deployments'
			},
			{
				label: 'Reserve POL Value',
				to: '/thorchain_reserve_pol_value'
			},
			{
				label: 'Reserve POL P/L',
				to: '/thorchain_reserve_pol_unrealized_pl'
			},
			{
				label: 'Treasury MSig Deployments',
				to: '/thorchain_treasury_msig_deployments'
			},
			{
				label: 'Treasury MSig Value',
				to: '/thorchain_treasury_msig_value'
			},
			{
				label: 'Treasury MSig P/L',
				to: '/thorchain_treasury_msig_unrealized_pl'
			},
			{
				label: 'Treasury Old Value',
				to: '/thorchain_treasury_old_value'
			}
		]
	},
	// Network
	{
		label: 'Network',
		icon: <FaNetworkWired />,
		to: undefined,
		dropDown: 1,
		dropDownLinksArray: [
			{
				label: 'Earnings/Distribution',
				to: '/thorchain_earnings_breakdown'
			},
			{
				label: 'Income Breakdown',
				to: '/thorchain_income_breakdown'
			},
			{
				label: 'Rune Burn',
				to: '/thorchain_rune_burn'
			},
			{
				label: 'Rune APR',
				to: '/thorchain_rune_bonding_apr'
			},
			{
				label: 'Total Value Locked',
				to: '/thorchain_tv_locked'
			},
			{
				label: 'Total Value Pooled',
				to: '/thorchain_tv_pooled'
			},
			{
				label: 'Total Value Bonded',
				to: '/thorchain_tv_bonded'
			},
			{
				label: 'Rune Supply',
				to: '/thorchain_rune_supply'
			},
			{
				label: 'Liquidity Fees',
				to: '/thorchain_liquidity_fees'
			},
			{
				label: 'Bond Share Factor',
				to: '/thorchain_bond_share_factor'
			},
			// {
			// 	label: 'Pct Of Earnings From Liq Fees',
			// 	to: '/thorchain_pct_earnings_from_liq_fees'
			// },
			{
				label: 'Deterministic Price',
				to: '/thorchain_deterministic_rune_price'
			}
			// {
			// 	label: 'Reserve ILP Exposure',
			// 	to: '/thorchain_reserve_ilp_exposure'
			// }
		]
	},
	//Addresses
	{
		label: 'Addresses',
		icon: <TbAddressBook />,
		to: undefined,
		dropDown: 1,
		dropDownLinksArray: [
			{
				label: 'New Addresses',
				to: '/thorchain_new_addresses'
			},
			{
				label: 'Active Addresses',
				to: '/thorchain_active_addresses'
			}
		]
	},
	//Exchanges
	{
		label: 'Affiliates',
		icon: <BsBank />,
		to: undefined,
		dropDown: 1,
		dropDownLinksArray: [
			{
				label: 'Affiliate Fees',
				to: '/thorchain_affiliate_fees'
			},
			{
				label: 'Total Affiliate Fees',
				to: '/thorchain_total_affiliate_fees'
			},
			{
				label: 'Swap Volume',
				to: '/thorchain_swap_volume_by_aff'
			},
			{
				label: 'Total Swap Volume',
				to: '/thorchain_total_swap_volume_by_aff'
			},
			{
				label: 'Swap Volume PCT',
				to: '/thorchain_pct_swap_volume_by_aff'
			},
			{
				label: 'Swap Count',
				to: '/thorchain_swap_count_by_aff'
			},
			{
				label: 'Total Swap Count',
				to: '/thorchain_total_swap_count_by_aff'
			}
			// {
			// 	label: 'Saver Adds',
			// 	to: '/thorchain_saver_adds_by_dex'
			// }
		]
	},
	// TCY
	{
		label: 'TCY',
		icon: <FaRegMoneyBillAlt />,
		to: undefined,
		dropDown: 1,
		dropDownLinksArray: [
			{
				label: 'TCY Staking',
				to: '/thorchain_tcy_staking'
			},
			{
				label: 'TCY APR',
				to: '/thorchain_tcy_staking_apr'
			},
			{
				label: 'TCY/ᚱUNE',
				to: '/thorchain_tcy_rune_prices'
			},
			{
				label: 'TCY Yield',
				to: '/thorchain_tcy_yield'
			}
		]
	},
	// TRADE ASSETS
	{
		label: 'Trade Assets',
		icon: <RiExchangeDollarLine />,
		to: undefined,
		dropDown: 1,
		dropDownLinksArray: [
			{
				label: 'TA Balances',
				to: '/thorchain_trade_asset_balances_usd'
			},
			{
				label: 'TA/SwapFees',
				to: '/thorchain_trade_asset_to_swap_fees_ratio'
			},
			{
				label: 'TA/SwapVolume',
				to: '/thorchain_trade_asset_to_swap_volume_ratio'
			},
			{
				label: 'TA/PoolDepth',
				to: '/thorchain_trade_asset_to_pool_depth_ratio'
			}
		]
	},
	// SECURE ASSETS
	{
		label: 'Secured Assets',
		icon: <RiSecurePaymentFill />,
		to: undefined,
		dropDown: 1,
		dropDownLinksArray: [
			{
				label: 'SA Balances',
				to: '/thorchain_secure_asset_balances_usd'
			},
			{
				label: 'SA/SwapFees',
				to: '/thorchain_secure_asset_to_swap_fees_ratio'
			},
			{
				label: 'SA/SwapVolume',
				to: '/thorchain_secure_asset_to_swap_volume_ratio'
			},
			{
				label: 'SA/PoolDepth',
				to: '/thorchain_secure_asset_to_pool_depth_ratio'
			}
		]
	},
	// Balances
	{
		label: 'Balances',
		icon: <TbWallet />,
		to: undefined,
		dropDown: 1,
		dropDownLinksArray: [
			{
				label: 'Module Balances',
				to: '/thorchain_module_balances'
			},
			{
				label: 'Rune Distribution',
				to: '/thorchain_rune_distribution'
			},
			{
				label: 'Dev Fund Balance',
				to: '/thorchain_devfund_earnings'
			},
			{
				label: 'Mkt Fund Balance',
				to: '/thorchain_mktfund_earnings'
			},
			{
				label: 'CEX Balances',
				to: '/thorchain_cex_balance'
			}
		]
	},
	// // External
	{
		label: 'Competitors',
		icon: <FiExternalLink />,
		to: undefined,
		dropDown: 1,
		dropDownLinksArray: [
			{
				label: 'Pct of Total Vol',
				to: '/volume_competitors_pct_of_swap_vol'
			},
			{
				label: 'Swap Volume',
				to: '/thorchain_competitors_swap_vol'
			}
		]
	},
	// Thorswap
	{
		label: 'THORSwap',
		icon: <SLinkLogo src={THORSwapLogo} />,
		to: undefined,
		dropDown: 1,
		dropDownLinksArray: [
			{
				label: 'THOR Dashboard',
				to: '/thorswap_dashboard'
			},
			{
				label: '[v]THOR/ᚱUNE',
				to: '/thorswap_thor_n_vthor_rune_prices'
			},
			{
				label: 'Staking TVL',
				to: '/thorswap_staking'
			},
			{
				label: 'Staking Yield',
				to: '/thorswap_staking_yield'
			},
			{
				label: 'Staking APR',
				to: '/thorswap_staking_apr'
			},
			{
				label: 'THOR Burned',
				to: '/thorswap_burn_stats'
			},
			{
				label: 'THOR Distribution',
				to: '/thorswap_thor_distribution'
			},
			{
				label: 'vTHOR Distribution',
				to: '/thorswap_vthor_distribution'
			},
			{
				label: 'Affiliate Fees TC',
				to: '/thorswap_affiliate_fees'
			}
		]
	}
]
export default SidebarList
